import axios from 'axios';

// 创建一个不带认证信息的API实例用于公共访问
const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  headers: {
    'Content-Type': 'application/json',
  },
});

// 按代码搜索样板 - 公共接口
export const searchPatternByCode = async (code) => {
  try {
    const response = await publicApi.get(`/public/patterns/search/code?code=${encodeURIComponent(code)}`);
    return response.data;
  } catch (error) {
    console.error('按代码搜索样板失败:', error);
    throw error;
  }
};

// 按图像搜索样板 - 公共接口
export const searchPatternByImage = async (imageData) => {
  try {
    const response = await publicApi.post(`/public/patterns/search/image`, { imageData });
    return response.data;
  } catch (error) {
    console.error('按图像搜索样板失败:', error);
    throw error;
  }
};

// 获取单个样板详情 - 公共接口
export const getPatternDetailsById = async (id) => {
  try {
    const response = await publicApi.get(`/public/patterns/${id}`);
    return response.data;
  } catch (error) {
    console.error('获取样板详情失败:', error);
    throw error;
  }
};
